import { PermissionsResponseModel, PermissionGroupResponsemodel } from './RoleResponseModel';
/* 
Model defined for Maintaining Role Requests. It can also be used for transferring model
*/

export class RoleRequestModel {
    id: string;
    name: string;
    partnerId: string;
    permissions: string[];
    isAdmin: boolean;
    constructor(name?: string, partnerId?: string) {
        this.name = name;
        this.partnerId = partnerId;
    }
}
export class AddPermissionModel {
    name: string;
    partnerId: string;
    role_type: string;
    permissions = new Array<PermissionGroupResponsemodel>();
    constructor(name: string, partnerId: string, role_type: string, permissions = new Array<PermissionGroupResponsemodel>()) {
        this.name = name;
        this.partnerId = partnerId;
        this.role_type = role_type;
        this.permissions = permissions;
    }
}


// WEBPACK FOOTER //
// ./src/app/_models/role/RoleRequestModel.ts